// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  min-height: var(--headerHeight);
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #FFF;
}
.header__container {
  margin: 0 auto;
  max-width: 1228px;
  width: 100%;
  display: flex;
  align-items: center;
}
@media screen and (min-width: 1200px) {
  .header__container {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.header .logo-wrapper {
  font-size: 0;
}
.header .burger-header {
  border-radius: 16px;
  background: rgba(20, 37, 41, 0.1);
  width: 40px;
  height: 40px;
}
.header .logo {
  width: auto;
  max-width: 100%;
  position: relative;
  top: 1.5px;
}
.header a {
  color: currentColor;
}
.header nav {
  margin: 0 0 0 auto;
}
.header .navbar-nav {
  display: none;
  align-items: center;
  gap: 8px;
}
.header .navbar-nav .nav-item {
  padding: 8px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease-out;
  border: 2px solid transparent;
  border-width: 1px 0;
  position: relative;
}
.header .navbar-nav .nav-item:after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 0;
  height: 2px;
  z-index: 1;
  transition: width 0.3s ease-out;
  background-color: #FFDF00;
}
.header .navbar-nav .nav-item:hover:after {
  animation: borderAnim 0.3s ease-out both;
}
.header .navbar-nav .nav-item.nav-active {
  animation: none;
}
.header .navbar-nav .nav-item.nav-active:after {
  width: 100%;
}
@media screen and (min-width: 486px) {
  .header {
    position: fixed;
    padding-top: 0;
    padding-bottom: 0;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    background: rgba(0, 0, 0, 0.5);
    border-bottom: 1px solid rgba(222, 226, 230, 0.15);
  }
  .header .select-btn {
    background-color: rgba(255, 255, 255, 0.4);
  }
  .header .menu__list .heading-3 {
    color: rgba(255, 255, 255, 0.8);
  }
}
@media screen and (min-width: 768px) {
  .header .navbar-nav {
    display: flex;
  }
  .header .navbar-nav .nav-item {
    margin: 0 10px;
  }
}
@media screen and (min-width: 1024px) {
  .header nav {
    margin: 0 auto;
    padding-right: 143px;
  }
}

@keyframes borderAnim {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
.burger-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  cursor: pointer;
  border: none;
  position: relative;
  z-index: 20;
  margin-left: auto;
}
.burger-menu .burger-menu__inner {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.burger-menu .burger-menu__inner > span {
  position: absolute;
  width: 14px;
  height: 2.2px;
  border-radius: 2px;
  left: 1px;
  transition: 0.2s ease 0s;
  transition-property: transform, opacity, background-color;
  background-color: #fff;
}
.burger-menu .burger-menu__inner .burger-menu__top {
  top: 4px;
}
.burger-menu__inner.active .burger-menu__top {
  transform: translate3d(0, 3px, 0) rotate(45deg);
  transition: 0.2s ease 0.1s;
  background-color: #000;
}

.burger-menu .burger-menu__inner .burger-menu__bottom {
  top: 11px;
}
.burger-menu__inner.active .burger-menu__bottom {
  transform: translate3d(0, -4px, 0) rotate(-45deg);
  transition: 0.2s ease 0.1s;
  background-color: #000;
}

.burger-menu:focus {
  opacity: 1;
}
@media screen and (min-width: 768px) {
  .burger-menu {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/Header/Header.scss","webpack://./src/assets/styles/color-variables.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAEA;EAEE,+BAAA;EAEA,WAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WCVM;ADSR;AAEE;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AEUI;EFPA;IACE,kBAAA;IACA,mBAAA;EAAJ;AACF;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,mBAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;AADJ;AAIE;EAEE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AALJ;AAOI;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;AALN;AAMM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,+BAAA;EACA,yBAAA;AAJR;AAMM;EACE,wCAAA;AAJR;AAMM;EACE,eAAA;AAJR;AAKQ;EACE,WAAA;AAHV;AElEI;EFjBJ;IA4FI,eAAA;IAEE,cAAA;IACA,iBAAA;IAEF,2BAAA;IACA,mCAAA;IACA,8BAAA;IACA,kDAAA;EAPF;EAWE;IACE,0CAAA;EATJ;EAeI;IACE,+BAAA;EAbN;AACF;AE/EI;EFgGA;IACE,aAAA;EAdJ;EAeI;IACE,cAAA;EAbN;AACF;AEnFI;EFoGA;IACE,cAAA;IACA,oBAAA;EAdJ;AACF;;AAkBA;EACE;IACE,QAAA;EAfF;EAiBA;IACE,WAAA;EAfF;AACF;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAfF;AAgBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAdJ;AAeI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,yDAAA;EACA,sBAAA;AAbN;AAkBM;EACE,QAJI;AAZZ;AAiBiB;EACP,+CANE;EAOF,0BAAA;EACA,sBC3KF;AD4JR;;AAUM;EACE,SAJI;AAHZ;AAQiB;EACP,iDANE;EAOF,0BAAA;EACA,sBC3KF;ADqKR;;AAWE;EACE,UAAA;AARJ;AE1JI;EFuHJ;IA8CI,aAAA;EAPF;AACF","sourcesContent":["@import \"src/assets/styles/variables\";\n\n.header {\n  //background-color: #fff;\n  min-height: var(--headerHeight);\n  //position: relative;\n  width: 100%;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  padding: 4px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: $white;\n  &__container{\n    margin: 0 auto;\n    max-width: 1228px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n  }\n  @include screen(lg){\n    &__container{\n      padding-left: 16px;\n      padding-right: 16px;\n    }\n  }\n  .logo-wrapper{\n    font-size: 0;\n  }\n\n  .burger-header{\n    border-radius: 16px;\n    background: rgba(20, 37, 41, 0.10);\n    width: 40px;\n    height: 40px;\n  }\n\n  .logo{\n    //height: 16px;\n    width: auto;\n    max-width: 100%;\n    position: relative;\n    top: 1.5px;\n  }\n\n  a {\n    color: currentColor;\n  }\n\n  nav{\n    margin: 0 0 0 auto;\n  }\n  .navbar-nav{\n    display: none;\n    align-items: center;\n    gap: 8px;\n\n    .nav-item {\n      padding: 8px;\n      height: 64px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: opacity .3s ease-out;\n      border: 2px solid transparent;\n      border-width: 1px 0;\n      position: relative;\n      &:after{\n        content: '';\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        bottom: 0;\n        width: 0;\n        height: 2px;\n        z-index: 1;\n        transition: width .3s ease-out;\n        background-color: #FFDF00;\n      }\n      &:hover:after{\n        animation: borderAnim .3s ease-out both;\n      }\n      &.nav-active{\n        animation: none;\n        &:after{\n          width: 100%;\n        }\n      }\n    }\n  }\n  @include screen(xs) {\n    position: fixed;\n    padding: {\n      top: 0;\n      bottom: 0;\n    };\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    background: rgba(0,0,0,.5);\n    border-bottom: 1px solid rgba(222,226,230,.15);\n    .logo{\n      //filter: brightness(0) invert(1);\n    }\n    .select-btn{\n      background-color: rgba(#fff, .4);\n    }\n    .burger-menu{\n\n    }\n    .menu__list{\n      .heading-3{\n        color: rgba(#fff, .8);\n      }\n    }\n  }\n  @include screen(sm){\n    .navbar-nav{\n      display: flex;\n      .nav-item{\n        margin: 0 10px;\n      }\n    }\n  }\n  @include screen(md){\n    nav{\n      margin: 0 auto;\n      padding-right: 143px;\n    }\n  }\n}\n\n@keyframes borderAnim {\n  0%{\n    width: 0;\n  }\n  100%{\n    width: 100%;\n  }\n}\n.burger-menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  position: relative;\n  z-index: 20;\n  margin-left: auto;\n  .burger-menu__inner {\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    > span {\n      position: absolute;\n      width: 14px;\n      height: 2.2px;\n      border-radius: 2px;\n      left: 1px;\n      transition: 0.2s ease 0s;\n      transition-property: transform, opacity, background-color;\n      background-color: #fff;\n    }\n    $pairs: 'top' 4px (translate3d(0, 3px, 0) rotate(45deg)) 1,\n    'bottom' 11px (translate3d(0, -4px, 0) rotate(-45deg)) 1;\n    @each $item, $step, $transform, $opacity in $pairs {\n      .burger-menu__#{$item} {\n        top: $step;\n        @at-root .burger-menu__inner.active .burger-menu__#{$item}{\n          transform: $transform;\n          transition: 0.2s ease 0.1s;\n          background-color: $black;\n        }\n      }\n    }\n  }\n  &:focus{\n    opacity: 1;\n  }\n  @include screen(sm) {\n    display: none;\n  }\n}\n","$blue: #1B2C74;\n$iris-blue: #00A9E0;\n$green: #0DB4A7;\n$orange: #FBB03B;\n$red: #E63200;\n$white: #FFF;\n$grey: #8994A3;\n$dark: #333;\n$black: #000;\n\n@function dm-color($color: $blue, $tone: 600) {\n  @if $tone == 600 {\n    @return $color;\n  }\n  @return map-get(\n                  map-get($color-variations, $color),\n                  $tone\n  );\n}\n\n$color-variations: (\n        $blue: (\n                400: #2C79E7,\n                600: $blue,\n        ),\n        $grey: (\n                50: #F2F4F7,\n                100: #E1E6EC,\n                200: #F2F4F6,\n                300: #F7F9FC,\n                400: #CAD5E4,\n                500: #F3F3FA,\n                600: $grey,\n        ),\n        $dark: (\n                500: #566170,\n                600: $dark,\n                900: $black,\n        ),\n        $green: (\n                500: #0DC3A7,\n                600: $green,\n        ),\n);\n","@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap');\n\n@import \"color-variables\";\n\n$intel: 'Inter', sans-serif;\n$montserrat: 'Montserrat', sans-serif;\n$sfCompact: 'SF-Compact', sans-serif;\n$brutalType: 'BrutalType', sans-serif;\n\n// BREAKPOINTS\n$media-xs: 486px;\n$media-sm: 768px;\n$media-md: 1024px;\n$media-lg: 1200px;\n$media-xl: 1440px;\n\n@mixin screen($size, $type: min, $pixels: $media-xs) {\n  @if $size == \"xs\" {\n    @media screen and ($type + -width: $media-xs) {\n      @content;\n    }\n  } @else if $size == \"sm\" {\n    @media screen and ($type + -width: $media-sm) {\n      @content;\n    }\n  } @else if $size == \"md\" {\n    @media screen and ($type + -width: $media-md) {\n      @content;\n    }\n  } @else if $size == \"lg\" {\n    @media screen and ($type + -width: $media-lg) {\n      @content;\n    }\n  } @else if $size == \"xlg\" {\n    @media screen and ($type + -width: $media-xl) {\n      @content;\n    }\n  } @else if $size == \"custom\" {\n    @media screen and ($type + -width: $pixels + px) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n//BETWEEN BREAKPOINTS\n@mixin media-breakpoint-between($minW, $maxW) {\n  @media screen and (min-width: $minW - 1px) and (max-width: $maxW) {\n    @content;\n  }\n}\n\n@mixin fontVariation($size: \"16px\", $weight: \"500\", $lineHeight: \"20px\") {\n  font-size: $size;\n  line-height: $weight;\n  font-weight: $lineHeight;\n}\n\n@mixin lineClamp($line) {\n  display: -webkit-box;\n  -webkit-line-clamp: #{$line};\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin scrollBar($width, $height) {\n  &::-webkit-scrollbar {\n    width: $width;\n    height: $height;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #e1e6ec;\n    border-radius: 8px;\n  }\n}\n\n%positioned {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n}\n\n%flex-centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
